import "core-js/modules/web.dom-collections.iterator.js";
export const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export const daysInMonth = (month, year) => {
  const n = new Date(year, month, 0).getDate();
  return Array.from(Array(n).keys());
};